import { Icon } from './Icon';
import { BoxIcon } from './BoxIcon';
import { BpIcon } from './BpIcon';
import { FaIcon } from './FaIcon';


Icon.Box = BoxIcon;
Icon.Bp = BpIcon;
Icon.Fa = FaIcon;
export { Icon };
